import { trackEvent } from '@/shared/analytics';

const CTA_EVENTS = {
  signup: 'click_signup_cta',
  contact: 'click_contact_cta',
} as const;

type CtaIntent = keyof typeof CTA_EVENTS;

function isCtaIntent(value: string | undefined): value is CtaIntent {
  return value !== undefined && Object.hasOwn(CTA_EVENTS, value);
}

export function initializeCtaTracking(): void {
  document.addEventListener('click', (event) => {
    const target = (event.target as HTMLElement).closest<HTMLElement>('[data-cta-intent]');
    if (!target) return;

    const intent = target.dataset.ctaIntent;
    if (!isCtaIntent(intent)) return;

    trackEvent(CTA_EVENTS[intent], { cta_location: target.dataset.ctaLocation });
  });
}
